import useSetChartSelections from "features/Charting/hooks/useSetChartSelections";
import { useCallback, useMemo } from "react";
import { MetadataType } from "types/metadata";
import { CircuitMetric, ExerciseMetric } from "types";

function useChartMetrics() {
  const setSelections = useSetChartSelections();

  const setMeasureMetricAtIndex = useCallback(
    (measureIndex: number) => (event: unknown, measureMetric: ExerciseMetric | CircuitMetric) => {
      setSelections((prev) => ({
        measures: prev.measures.map((prevMeasure, prevMeasureIndex) => {
          if (measureIndex !== prevMeasureIndex) {
            return prevMeasure;
          }

          if (prevMeasure.type === MetadataType.EXERCISE) {
            return { ...prevMeasure, metric: measureMetric as ExerciseMetric };
          }

          if (prevMeasure.type === MetadataType.CIRCUIT) {
            return { ...prevMeasure, metric: measureMetric as CircuitMetric };
          }

          throw new Error("You can only select a metric on an Exercise or Circuit");
        }),
      }));
    },
    [setSelections]
  );

  return useMemo(
    () => ({
      onChangeAtIndex: setMeasureMetricAtIndex,
      getOptionLabel: (option: ExerciseMetric | CircuitMetric) => option.name,
    }),
    [setMeasureMetricAtIndex]
  );
}
export default useChartMetrics;
